<script lang="ts">
    
    import { setContext } from "svelte";
    import { readable, writable } from "svelte/store";
    import type { Fn } from "../../global";
    import type { State } from "../../Model/State";

    const _forceInput = writable(false);
    const controlStates = new Map<State, Fn>();
    const forceInput = readable(false, set => _forceInput.subscribe(set));
    
    let allControlsValid = true;

    setContext('registerValidationState', registerValidationState);
    setContext('unregisterValidationState', unregisterValidationState);
    setContext('forceInput', forceInput);

    export function validate(): void {
        $_forceInput = true;
    }

    export function isValid(): boolean {
        return allControlsValid;
    }

    function registerValidationState(controlState: State<boolean>) {
        if (controlStates.has(controlState)) {
            return;
        }
        let unsub: Fn;
        controlStates.set(controlState, () => unsub());
        unsub = controlState.subscribe(updateFormState);
    }

    function unregisterValidationState(controlState: State<boolean>) {
        if (!controlStates.has(controlState)) {
            return;
        }
        //Llamamos a la funcion de desuscribir antes de eliminar el estado
        controlStates.get(controlState)();
        controlStates.delete(controlState);
        updateFormState();
    }

    function updateFormState(): void {
        allControlsValid = [...controlStates.keys()].every(({ value }) => value);
    }

</script>

<slot isValid={allControlsValid} isInvalid={!allControlsValid} />
